// apps/web/src/lib/persisted-ops.client.ts — AUTO-GENERATED by scripts/build-persisted-ops.ts.
// DO NOT EDIT — re-run `pnpm build:persisted-ops` to regenerate.
//
// Per D-09-01 (Phase 9 plan 09-01): web client uses this map to
// look up the sha256 hash for an outgoing operation by name. The hash
// is sent via extensions.persistedQuery.sha256Hash; the server verifies
// against apps/api/src/lib/persisted-ops-seed.ts.

export const PERSISTED_OPS_CLIENT_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    AreasSettings:
      "f4a6d6f5749be7d78190f13240ecc37300467eb29e5bf14bb23e05925a6b32a9",
    Availability:
      "6a96dea70bd45e796220c75c5cb76bbb40ed11e5bd1a93c6a664f90221a10c48",
    AvailabilityMonthCalendar:
      "494709d28d22d516cbd7c57aba632d58f77367ff1d7a0c448348563ebe18758d",
    BlockedPeriodsCalendar:
      "7a91c5231f1859fd200dd2cdea219d951433d555a69e6496cd108c559afe46d1",
    BlockedPeriodsSettings:
      "e9d6461a274ea2b8104e52fac7bc209f5abae7e9bf17b419e34c2130a3aee0a9",
    CancelReservationAdmin:
      "42b9b5cfb7022db6a120513e92bba381b1e6d8ce0041b16997cac9ffed056ba6",
    CancelReservationByToken:
      "087d362f857826f6ef7adc4ad5969551eb30ff0368076ad51c4f739978e692d3",
    CapacityConfigsSettings:
      "8a203e5587c2d7ea309ade176f16fcfc50e6454d8a148442e091277c1dd0953c",
    CompleteOnboarding:
      "aadfd2770dd0ea7876a9002b5309e5be187f9c2bfc333243be055e7ce541e864",
    ConfirmAdminEmailChangePage:
      "a42492bc3a3b5bc07f120f3f596ff1299ab80c9687ef83e26c6e70cea4deddcf",
    ConfirmToken:
      "4cc7cbb5b44f8f2b23e0c66bf731aa935db2654c881c6753f4ea9cac4692e2cf",
    CreateBlockedPeriodCalendar:
      "f3545300b86ccef4a83af3d5083a87f074282853df32836099a1c47bef75eac1",
    CreateBlockedPeriodSettings:
      "7770f3d2d61cea4b0122832dededb6f87abea97df2ad087daefc8c72bde1e1cc",
    CreateManualReservationAdmin:
      "6a1301a5b424fe975636dc11610099b6f9352abee37cd708c68344b940899cc2",
    CreateReservation:
      "cf6adfebdfb7a734e93afc5a1d7b0313a3cf2a161efbbfd24aaa1f7552f69ed1",
    CreateSlotDefinitionSettings:
      "0e60155d3ed2e2cf130b0f82abf5e75bbc8710dd4dbf3d081a880fc0f918a8d4",
    DateSummaryCalendar:
      "a0495e9d0fa619bd2ff0c581374191cc85b745e8ab6563879fac7126b9bbfab2",
    DateSummaryToday:
      "afd7e0e7c8d363822682c1f924586a21b08a80f9aeeeb3622332027c532d62d2",
    DayExceptionsSettings:
      "87632eba08951fa2473e41f40689da4a2c688be8a37ec025bbb64aa0dc649fec",
    DeleteBlockedPeriodCalendar:
      "06b49418e3d276dfd18a7ab65a988f11af846e6aa7849d76185560a701293628",
    DeleteBlockedPeriodSettings:
      "86702c5694e2fe0aadb32bd0ea7df527a4677c9630f22a5528c1e4de883d7eac",
    DeleteDayExceptionSettings:
      "392e28156cf9f8eb03f0ea4cee3f6736a162432fa7b9fbdffed253d0ba6dc00d",
    DeleteSlotDefinitionSettings:
      "aac75da6d98582237513121ed167b0c8e03b38a9bdb1b4b5e66ce7d05f2d97a3",
    GetAvailableSlots:
      "beb6b01d03822c818fd769618491e7ee93f07908ce4b23021bfb3bb54def753d",
    GetReservationByToken:
      "d3dbbd231ac06d4ec7f0073427b299adfc98cf32031e47034371d6c122b3f68c",
    GetRestaurant:
      "466559d54f7dc9ab5b3cbb3b9c3329f6d504f46d24e48ff85a66e1c435672e95",
    LoginAuth:
      "a88614ed9162b7eb86284ebab860c240de854acad512a55b7aaad5e8582f3d7f",
    LoginPage:
      "29e5b23f628476a403ddd32c7313110195173818b652e269eb444924f8ee48b0",
    MarkArrivedAdmin:
      "17ee3e8e5949811872ef12e278d3e9855e8f0eb27cfa6f7a9f7d952c1d97144b",
    MarkNoShowAdmin:
      "a4922cd4bf2aa5268cc73a84a5ba5e12046fe4e090d8da2bc9c208615d6b0d9f",
    MeAccount:
      "1054abbd78de02e659044504bc989114594ef75daa77f9077d085405e72428fe",
    MeAuth: "5cd8b8d9658656e16d658ff7bf80c2a6761ad193d980dd21ca04a3c7a89b6328",
    ModifyReservationByToken:
      "c1a0d6896aba5c43fea821c9394c2b10de069cea7931a6eda6a8ac603fe5e62c",
    OnboardingReviewContext:
      "9b0afd186bf35a3f6eec1b6141a3b67b0fe58a26f95e1c5458ad5187ae596ff6",
    OpeningHoursSettings:
      "82f797fac2dcd856e0ea1fc105860bcb1e269802d86cea7a12f4fc0355d03fa9",
    RequestAdminEmailChangeAccount:
      "d0039fc0e0f969252b0d292ce0771529cb5011ad9d353643b65d00508b4a3e74",
    ReservationAdmin:
      "23e04f6d9b8f84ac9abb9064240b02be62225b070cb8faf3c3c085b2e6ee7633",
    ReservationsPaginated:
      "f094bb924f52fd54c1b8e6b278b74b0f0dfe225e13c7646c8de685facb69bd16",
    RestaurantManual:
      "9cabe45fdcbe900adba0e54d75573e02ad57130a2fcc6a0d259fe07cdb49f1c3",
    RestaurantSettings:
      "97827cedaa81e1ee6bef7a856fd70b2d0d32f14225f68f43e2b8b8a28a718793",
    SaveOnboardingAddress:
      "a46863d81b30a0543e4a66abe7e60b3f426be3bdfc1dc5d24cb645aa4ed477c5",
    SaveOnboardingCapacity:
      "b8c5fc17db7509a1e6f65050b632d22f8446b22a6dee9f13d852323a7db7cbce",
    SaveOnboardingHours:
      "ca8eeec16e68280183f3bb1704b9c416fabdf30cadba9f9a933a5df3c6ec4cc6",
    SetStatusAdmin:
      "2158f863f2232d825a4ed8019e55f5d9e2aa061c70016db8d4dd57cbd180cd7a",
    SignupRequest:
      "4c08a2aa800e92fcf0099fe8fe04a243f89d28d7c678e443ac48f9ea3ed9920c",
    SlotDefinitionsManual:
      "5d982aaa13b8ae33f11b7f63f4a24e42a558a6851f310fcb1848c33116345db7",
    SlotDefinitionsSettings:
      "bcc44be1082fd4796f7fa00ad1b4b611781011c4a480ac73e46837d2d9fc797d",
    Slots: "e45fab8b1fd55d60670d0418bf5d609849a6f9d83048ff906b416819ea1b48a4",
    TodayReservations:
      "d95052d59e77ab06313d9374ef9ce2468d5d27235d80325840db9f8b9ed4fc0b",
    ToggleAreaSettings:
      "0ff5249368892ffbed1f28432acd93d11f2a5156a5107f58410128b8a402c084",
    UnblockDayCalendar:
      "73c6ab8758947b2f96943de2fb309fb82e298e12656382b2fd43e5482bd7114c",
    UpdateConfirmationModeSettings:
      "e8acd0b2306e3aacfb7be6460b4707f1447a1496d6e4f8c95d3ebf058b231c63",
    UpdateReservationAdmin:
      "cfec49d50dc2c00239f70a608f335b77616f9978abbd6c82870f047b86df2caf",
    UpdateRestaurantSettings:
      "19098618413fb06b589fdf03872b209bf6a6f1d434f91f32b2f2bbe5aa89ccdf",
    UpdateSlotDefinitionSettings:
      "153cd1ab3aabea04faa9e2e24e920b4ddd0567cf596faa1ed9f6f292916d6213",
    UpsertCapacityConfigSettings:
      "e5c07b94a183ca8d93bafd8fdbbfeef0cefd2cdb637605b64a80ea9efa2e0858",
    UpsertDayExceptionSettings:
      "d924832f60aa622d5b2ee72b488dad24297a4e1ca67244a5f6c2e0ed0ebc8713",
    UpsertOpeningHoursSettings:
      "760892db5aa6695eee4b2413bf531483af48643c6101ea6a8f8bb64ec062c129",
    VerifySignup:
      "f9d009e06ba85980595cec378d6fa549b6a161df8bd2e8eda35b6c2ed7159a87",
  });
